var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('kt-panel',[(_vm.ip_location !== 'IR')?_c('kt-panel-body',[_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\r\n                "+_vm._s(_vm.$t('label.ir_ip_error'))+"\r\n            ")])]):_c('kt-panel-body',[_c('dedicated-form',{attrs:{"form_data":_vm.form_data,"submit":_vm.submit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }